import { useEffect } from 'react';
import { GetUser } from 'store/slices/authSlice';
import { OpenSmsRunOutAlerts } from 'store/slices/calendarSlice';
import { getSmsAlertSettings } from 'utils/smsAlertSettings';
import { shouldShowSmsAlert } from 'utils/smsAlertRuntime';

// Route changes retain the login marker in memory; credentials are never written
// to additional browser storage. Persist only non-sensitive alert timestamps.
const sessions = new Map();
const shownAt = new Map();
const lastShown = (key) => {
  try { return Number(localStorage.getItem(key)) || shownAt.get(key) || 0; }
  catch { return shownAt.get(key) || 0; }
};

export const useSmsAlert = (user, token, dispatch) => {
  useEffect(() => {
    const salon = user?.salon;
    if (!salon || !user?.id || !salon.id) return undefined;
    const key = `beauti:sms-alert:${salon.id}:${user.id}`;
    const newLogin = !sessions.has(key) || sessions.get(key) !== token;
    if (!salon.sms_alert) {
      if (newLogin && Number(salon.is_empty_sms_alert) === 1) {
        sessions.set(key, token);
        dispatch(OpenSmsRunOutAlerts('open'));
      }
      return undefined;
    }
    sessions.set(key, token);
    const policy = getSmsAlertSettings(salon.sms_alert_settings);
    const now = Date.now();
    if (shouldShowSmsAlert({
      remaining: salon.sms_alert.remaining, settings: policy,
      snoozedUntil: salon.sms_alert.snoozed_until,
      now, lastShownAt: lastShown(key), newLogin,
    })) {
      shownAt.set(key, now);
      try { localStorage.setItem(key, String(now)); } catch { /* In-memory suppression remains available. */ }
      dispatch(OpenSmsRunOutAlerts('open'));
    }
    if (policy.frequency === 'login_only') return undefined;
    // Fetch current balances before deciding to alert again; do not reuse a stale balance.
    const timer = setInterval(() => dispatch(GetUser()), 60000);
    return () => clearInterval(timer);
  }, [user, token, dispatch]);
};
